export default [
  {
    title: '首頁',
    route: 'homepage',
    icon: 'HomeIcon',
  },
]
